"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphql = graphql;
/* eslint-disable */
const types = __importStar(require("./graphql"));
const documents = {
    "\n      query GetProductBySku($skus: [String!]) {\n        search(\n          language: \"no-nb\"\n          filter: { type: PRODUCT, include: { skus: $skus } }\n        ) {\n          edges {\n            node {\n              name\n              path\n            }\n          }\n        }\n      }\n    ": types.GetProductBySkuDocument,
    "\n      query GetAllFreight($shapeIdentifiers: [String!], $after: String) {\n        search(\n          filter: { include: { shapeIdentifiers: $shapeIdentifiers } }\n          after: $after\n        ) {\n          edges {\n            node {\n              ... on Product {\n                id\n                name\n                matchingVariant {\n                  price\n                  name\n                  sku\n                }\n              }\n            }\n          }\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n        }\n      }\n    ": types.GetAllFreightDocument,
    "\n      query GetAllSubscriptionPlans(\n        $shapeIdentifiers: [String!]\n        $after: String\n      ) {\n        search(\n          filter: { include: { shapeIdentifiers: $shapeIdentifiers } }\n          after: $after\n        ) {\n          edges {\n            node {\n              ... on Product {\n                id\n                name\n                matchingVariant {\n                  name\n                  sku\n                }\n              }\n            }\n          }\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n        }\n      }\n    ": types.GetAllSubscriptionPlansDocument,
    "\n      query GetBookClubPlans($shapeIdentifiers: [String!], $after: String) {\n        search(\n          filter: { include: { shapeIdentifiers: $shapeIdentifiers } }\n          after: $after\n        ) {\n          edges {\n            node {\n              ... on Product {\n                id\n                name\n                matchingVariant {\n                  name\n                  sku\n                }\n              }\n            }\n          }\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n        }\n      }\n    ": types.GetBookClubPlansDocument,
};
function graphql(source) {
    return documents[source] ?? {};
}
